export default "__VITE_ASSET__6xWGOGbT__"